<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      v-if="origin"
      :is-sticky="true"
      :back-button="true"
      :has-actions="!origin.protected">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'OriginList'}">
            Origines
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="origin && origin.name">
          <span
            id="originName"
            class="has-text-weight-normal has-text-grey-dark">{{ origin.name }}</span>
          <span
            v-if="origin.archived"
            class="has-text-weight-normal has-text-grey-dark"> - Archivée</span>
        </div>
      </template>
      <router-link
        v-if="!origin.parent"
        :to="{name: 'OriginCreate', query: {'parent': origin.pk}}"
        class="dropdown-item"
        slot="dropdown-content">
        <span class="icon is-medium"><i class="fas fa-plus-circle"></i></span><span class="is-margin-left-xsmall">Ajouter une Sous-origine</span>
      </router-link>
      <router-link
        v-if="!origin.protected"
        slot="dropdown-content"
        id="originEditButton"
        :to="{name: 'OriginEdit', params: {id: origin.pk}}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-edit"></i></span><span class="is-margin-left-xsmall">Modifier</span>
      </router-link>
      <a
        v-if="!origin.archived"
        slot="dropdown-content"
        class="dropdown-item"
        @click="confirmArchive(origin, 'Archiver origine')">
        <span class="icon is-medium"><i class="fas fa-archive"></i></span><span class="is-margin-left-xsmall">Archiver</span>
      </a>
      <a
        v-else
        slot="dropdown-content"
        class="dropdown-item"
        @click="unArchive(origin)">
        <span class="icon is-medium"><i class="fas fa-archive"></i></span><span class="is-margin-left-xsmall">Désarchiver</span>
      </a>
      <a
        v-if="!origin.protected"
        slot="dropdown-content"
        id="originDeleteButton"
        class="dropdown-item has-background-danger has-text-white"
        @click="removeOrigin">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span><span class="is-margin-left-xsmall">Supprimer</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="origin && !loading"
      :has-left-col-small="false"
      :has-left-col-small-size-fixed="true"
      :has-sticky-col-left="true">
      <div class="has-background-white is-padding">
        <h2 class="is-size-4 is-padding-bottom">
          <strong>Sous origines</strong>
          <span
            style="position: relative;"
            v-helper.bottom="'1iIY3JcZbM8aHLSpo2ET53'">
            <i class="fal fa-question-circle has-text-grey is-size-6 is-margin-left-xsmall"></i>
          </span>
        </h2>
        <div
          v-for="(child, idx) in children"
          :key="idx"
          class="is-border columns is-gapless">
          <div class="column is-padding-top-small is-padding-right is-padding-bottom-small is-padding-left">
            <span class="truncate"><span :id="`childOriginName${idx}`">{{ child.name }}</span></span>
            <span
              :id="`multidifTagChildOrigin${idx}`"
              v-if="child.multidiffusion"
              class="tag is-info is-xsmall">Multidiffusion</span>
            <span
              :id="`archivedTagChildOrigin${idx}`"
              v-if="child.archived"
              class="tag is-draft is-xsmall">Archivé</span>
            <span
              :id="`unArchivedTagChildOrigin${idx}`"
              v-else></span>
          </div>
          <div class="column is-narrow is-border-left">
            <router-link
              :id="`EditChildOrigin${idx}`"
              class="page-header-btn is-small is-minH100 is-borderless is-uppercase"
              :to="{name: 'OriginEdit', params: {id: child.pk}}">
              Modifier
            </router-link>
          </div>
          <div
            v-if="child.archived && !origin.archived"
            class="column is-narrow is-border-left">
            <a
              class="page-header-btn is-small is-minH100 is-borderless is-uppercase"
              :id="`UnArchivedChildOrigin${idx}`"
              @click.prevent.stop="unArchive(child)">Désarchiver</a>
          </div>
          <div
            v-else-if="!origin.archived"
            class="column is-narrow is-border-left">
            <a
              class="page-header-btn is-small is-minH100 is-borderless is-uppercase"
              :id="`ArchivedChildOrigin${idx}`"
              @click.prevent.stop="confirmArchive(child, 'Archiver sous-origine')">Archiver</a>
          </div>
          <div class="column is-narrow is-border-left">
            <a
              class="page-header-btn is-small is-minH100 is-borderless is-uppercase"
              :id="`deleteChildOrigin${idx}`"
              @click.prevent.stop="removeOriginChild(child)">Supprimer</a>
          </div>
        </div>
        <router-link
          tag="a"
          id="addSubOriginButton"
          :to="{name: 'OriginCreate', query: {'parent': origin.pk}}"
          class="has-link-grey is-border is-border--primary is-border--dashed columns is-gapless">
          <div class="column is-uppercase is-padding">
            Ajouter une sous-origine
          </div>
          <div class="column is-narrow is-padding">
            <span class="">
              <i class="fal fa-plus-square"></i>
            </span>
          </div>
        </router-link>
      </div>
    </page-content>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
export default {
  name: 'OriginVue',
  data () {
    return {
      origin: null
    }
  },
  computed: {
    originPk () {
      return this.$route.params.id
    },
    children () {
      return sortBy(this.origin.children, 'name')
    },
    isOriginChild () {
      if (this.origin.parent) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getOrigin()
  },
  methods: {
    async removeOriginChild (child) {
      let value = await this.$swal({
        title: 'Suppression sous-origine',
        text: 'Les contacts ne pourront plus être attribués à cette sous-origine. Si la sous-origines est attribuée à un contact, l\'action de suppression échouera, il faudra archiver la sous-origine ou modifier la sous-origine du contact en question.',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.ORIGIN, child.pk)
          this.$store.commit('removeOrigin', { originPk: child.pk })
          this.$toasted.global.success('Sous-origine supprimée')
          this.getOrigin()
        } catch (err) {
          console.log(err)
          if (err.response.data.exception === 'ORIGIN_USED_BY_CONTACTS') {
            this.confirmArchive(child, 'Un ou plusieurs contacts sont rattachés à cette sous-origine, suppression impossible.')
          } else if (err.response.data.exception === 'ORIGIN_USED_BY_RESERVATIONS') {
            this.confirmArchive(child, 'Une ou plusieurs réservations sont rattachées à cette sous-origine, suppression impossible.')
          } else if (err.response.data.exception === 'ORIGIN_USED_BY_PROGRAMS') {
            this.confirmArchive(child, 'Un ou plusieurs programmes sont rattachés à cette sous-origine, suppression impossible.')
          } else if (err.response.data.exception === 'ORIGIN_USED_BY_MGC_DIFFUSION') {
            this.confirmArchive(this.origin, 'Une ou plusieurs multidiffusion sont rattachés à cette sous-origine, suppression impossible.')
          } else {
            this.$toasted.global.danger('Erreur lors de la suppression de la sous-origine')
          }
        }
      }
    },
    async removeOrigin () {
      let value = await this.$swal({
        title: 'Suppression origine',
        text: 'La suppression de l\'origine entrainera la suppression des sous-origines qui lui sont liées. Si l\'une des sous-origines est  attribuée à un contact, l\'action de suppression échouera, il faudra archiver l\'origine ou modifier la sous-origine du contact en question.',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.delete(this.$resources.ORIGIN, this.originPk)
          this.$store.commit('removeOrigin', { originPk: this.originPk })
          this.$toasted.global.success('Origine supprimée')
          this.$router.push({ name: 'OriginList' })
        } catch (err) {
          console.log(err)
          if (err.response.data.exception === 'ORIGIN_USED_BY_CONTACTS') {
            this.confirmArchive(this.origin, 'Un ou plusieurs contacts sont rattachés à sous-origine de cette origine, suppression impossible.')
          } else if (err.response.data.exception === 'ORIGIN_USED_BY_RESERVATIONS') {
            this.confirmArchive(this.origin, 'Une ou plusieurs réservations sont rattachées à sous-origine de cette origine, suppression impossible.')
          } else if (err.response.data.exception === 'ORIGIN_USED_BY_PROGRAMS') {
            this.confirmArchive(this.origin, 'Un ou plusieurs programmes sont rattachés à sous-origine de cette origine, suppression impossible.')
          } else if (err.response.data.exception === 'ORIGIN_USED_BY_MGC_DIFFUSION') {
            this.confirmArchive(this.origin, 'Une ou plusieurs multidiffusion sont rattachés à sous-origine de cette origine, suppression impossible.')
          } else {
            this.$toasted.global.danger('Erreur lors de la suppression de l\'origine')
          }
        }
      }
    },
    async confirmArchive (origin, title) {
      let text
      if (origin.parent) {
        text = 'Les contacts ne pourront plus être rattachés à cette sous-origine.'
      } else {
        text = 'Les contacts ne pourront plus être rattachés aux sous-origines qui sont liées à cette origine.'
      }
      let value = await this.$swal({
        title: title,
        text,
        confirmButtonText: 'Archiver',
        focusConfirm: false
      })
      if (value.dismiss) return false
      if (value) {
        this.archivedOrigin(origin)
      }
    },
    async archivedOrigin (origin) {
      let updatedOrigin = Object.assign({}, origin)
      updatedOrigin.archived = true
      if (updatedOrigin.parent && 'pk' in updatedOrigin.parent && updatedOrigin.parent.pk) {
        updatedOrigin.parent = updatedOrigin.parent.pk
      }
      try {
        let { data } = await this.$api.put(this.$resources.ORIGIN, updatedOrigin.pk, updatedOrigin)
        this.$store.commit('updateOrigin', { origin: data })
        this.$toasted.global.success('Origine archivée')
        if (data.children) {
          for (let child of data.children) {
            this.$store.commit('updateOrigin', { origin: child })
          }
        }
        this.getOrigin()
      } catch (err) {
        console.log(err)
      }
    },
    async unArchive (origin) {
      let updatedOrigin = Object.assign({}, origin)
      updatedOrigin.archived = false
      if (updatedOrigin.parent) {
        updatedOrigin.parent = updatedOrigin.parent.pk
      }
      try {
        let { data } = await this.$api.put(this.$resources.ORIGIN, updatedOrigin.pk, updatedOrigin)
        this.$store.commit('updateOrigin', { origin: data })
        this.getOrigin()
        this.$toasted.global.success('Origine désarchivée')
      } catch (err) {
        console.log(err)
      }
    },
    async getOrigin () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.ORIGIN, this.originPk)
        this.origin = data
        this.loading = false
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    }
  }
}
</script>
